import RoleSelector from "components/Player/RoleSelector";
import { type Dispatch, type SetStateAction } from "react";
import ModalWrapper from "components/Wrappers/ModalWrapper";

export default function JoinAsPlayerModal({
  open,
  setOpen,
  joinGame,
}: {
  open: boolean,
  setOpen: Dispatch<SetStateAction<boolean>>,
  joinGame:(estate: string, role: string) => void,
}) {
  // Only for host to join


  return (
    <ModalWrapper open={open} setOpen={setOpen}>
      <h1 className="text-xl">Join as a player</h1>

      <RoleSelector
        customSelectRole={(e, r) => {
          joinGame(e, r);
          setOpen(false);
          return;
        }}
      />
    </ModalWrapper>
  )
}
